var exports = {
  "b": "commitHashWrapper__2S8Jas",
  "c": "copyButton__8F4Eph",
};

module.exports = exports;
